import ApiService from '@/services/core/api.service'

const ReplenishmentService = {
  async get (query = '') {
    return ApiService.get(`disbursement-associate/reports/credit-cards?${query}`)
  },

  async export (query = '') {
    return ApiService.get(`disbursement-associate/exports/credit-cards?${query}`)
  }
}

export default ReplenishmentService
